import { FormBuilder, Validators, } from "@angular/forms";
import { ExperimentDesignFormValidatorsService } from "./experiment-design-form-validators.service";
import { RecurrencePattern, } from "../../../shared/services/request.service";
import { ValidatorsService } from "../../../shared/services/validators.service";
import { addDays } from "date-fns";
import { ExperimentDesignShowHideService } from "../../services/experiment-design-show-hide.service";
var ExperimentDesignFormBuilderService = /** @class */ (function () {
    function ExperimentDesignFormBuilderService(formBuilder, formValidators, validatorsService, experimentDesignShowHideService) {
        this.formBuilder = formBuilder;
        this.formValidators = formValidators;
        this.validatorsService = validatorsService;
        this.experimentDesignShowHideService = experimentDesignShowHideService;
    }
    ExperimentDesignFormBuilderService.prototype.build = function (constraints) {
        return new ExperimentDesignFormService(this.formBuilder, this.validatorsService, this.formValidators, this.experimentDesignShowHideService, constraints).form;
    };
    return ExperimentDesignFormBuilderService;
}());
export { ExperimentDesignFormBuilderService };
var ExperimentDesignFormService = /** @class */ (function () {
    function ExperimentDesignFormService(formBuilder, validatorsService, formValidators, experimentDesignShowHideService, constraints) {
        var _this = this;
        this.formBuilder = formBuilder;
        this.validatorsService = validatorsService;
        this.formValidators = formValidators;
        this.experimentDesignShowHideService = experimentDesignShowHideService;
        this.constraints = constraints;
        this.formGroup = this.formBuilder.group({
            seedNeeds: constraints.design && constraints.design.requestedSeed
                ? this.initializeSeedNeedsArray(constraints.design)
                : this.formBuilder.array([]),
            numberOfReps: this.formBuilder.control({ value: null, disabled: false }, [Validators.required, Validators.min(1)]),
            numberOfTreatments: this.formBuilder.control({ value: null, disabled: false }, [Validators.required, Validators.min(1)]),
            numberOfSeedsPerCell: this.formBuilder.control({ value: 1 }, [
                Validators.min(1),
                Validators.max(3),
            ]),
            recurrencePattern: this.formBuilder.control(1),
            recurrenceEndDate: this.formBuilder.control({
                value: null,
                disabled: false,
            }),
            recurrenceWeekInterval: this.formBuilder.control({
                value: null,
                disabled: false,
            }),
            recurrenceDays: this.formBuilder.array([
                this.formBuilder.control(false),
                this.formBuilder.control(false),
                this.formBuilder.control(false),
                this.formBuilder.control(false),
                this.formBuilder.control(false),
            ]),
            treatments: this.formBuilder.array([]),
            harvestInstructions: this.formBuilder.group({
                embryoRescue: [false, [Validators.required]],
                minimumSeedsToReturn: [
                    null,
                    [Validators.required, Validators.min(0)],
                ],
                standardHarvest: [true, [Validators.required]],
                haploidInduction: [false, [Validators.required]],
                manyToOne: [false, [Validators.required]],
                uniquePedigree: [false, [Validators.required]],
            }),
            indexing: [false, [Validators.required]],
            pesticidesAllowed: [null, [Validators.required]],
            pesticidesAllowedAfterDays: [null, { disabled: true }],
            pesticideLifeOfPlant: [null],
            requestedSamplings: this.formBuilder.array([]),
            sprayStudy: [false],
            pollinationInstructions: this.formBuilder.group({
                pollinationCategory: this.formBuilder.control(null, [
                    Validators.required,
                ]),
                pollinationPreferences: this.formBuilder.array([], Validators.required),
                donorsNeeded: [false, [Validators.required]],
            }),
            seedRequestDesired: [false, [Validators.required]],
        }, { validator: this.formValidators.seedNeedsValidator() });
        this.form
            .get("numberOfTreatments")
            .valueChanges.subscribe(function (numberOfTreatments) {
            if (numberOfTreatments === null || numberOfTreatments === undefined) {
                return;
            }
            _this.addOrRemoveTreatments(numberOfTreatments);
            _this.addOrRemoveSeedNeedsTreatments(numberOfTreatments);
            var isSprayStudyOn = !!_this.form.get('sprayStudy').value;
            _this.applySprayStudyValidatorsToAllTreatments(isSprayStudyOn);
            _this.experimentDesignShowHideService.updateView(_this.formGroup, _this.constraints.requestPurposeId);
        });
        var treatmentsFA = this.form.get('treatments');
        treatmentsFA.valueChanges.subscribe(function () {
            _this.applySprayStudyValidatorsToAllTreatments(!!_this.form.get('sprayStudy').value);
        });
        this.form.get("recurrencePattern").valueChanges.subscribe(function (value) {
            var recurrenceEndDate = _this.form.get("recurrenceEndDate");
            var recurrenceWeekInterval = _this.form.get("recurrenceWeekInterval");
            var days = _this.form.get("recurrenceDays").value;
            if (value === RecurrencePattern.None) {
                recurrenceEndDate.clearValidators();
                recurrenceWeekInterval.clearValidators();
            }
            else if (value === RecurrencePattern.Weekly) {
                var validDaysOfWeek = [];
                for (var i = 0; i < days.length; i++) {
                    if (days[i] === true)
                        validDaysOfWeek.push(i + 1);
                }
                var maxDate = addDays(_this.constraints.plantingDate, 30);
                recurrenceEndDate.setValidators([
                    Validators.required,
                    _this.validatorsService.mustBeAfterDate(_this.constraints.plantingDate),
                    _this.validatorsService.mustBeOnOrBeforeDate(maxDate),
                    _this.validatorsService.allowedDaysOfWeek(validDaysOfWeek),
                    _this.validatorsService.isValidDate,
                ]);
                recurrenceWeekInterval.setValidators([
                    Validators.required,
                    Validators.min(1),
                ]);
            }
            recurrenceEndDate.updateValueAndValidity();
            recurrenceWeekInterval.updateValueAndValidity();
        });
        this.form.get("recurrenceDays").valueChanges.subscribe(function (value) {
            _this.form
                .get("recurrencePattern")
                .updateValueAndValidity({ onlySelf: false, emitEvent: true });
        });
        this.setupPesticideValidation();
    }
    Object.defineProperty(ExperimentDesignFormService.prototype, "form", {
        get: function () {
            return this.formGroup;
        },
        enumerable: true,
        configurable: true
    });
    ExperimentDesignFormService.prototype.setupPesticideValidation = function () {
        var _this = this;
        var pesticidesAllowed = this.formGroup.get("pesticidesAllowed");
        var pesticidesAllowedAfterDays = this.formGroup.get("pesticidesAllowedAfterDays");
        var pesticideLifeOfPlant = this.formGroup.get("pesticideLifeOfPlant");
        var updateFormState = function () {
            var selected = _this.constraints.pesticideInstructions.find(function (i) { return i.id === pesticidesAllowed.value; });
            if (selected && selected.requiresNumberOfDays) {
                pesticideLifeOfPlant.setValidators([Validators.required]);
                if (pesticideLifeOfPlant.value === false) {
                    pesticidesAllowedAfterDays.enable();
                    pesticidesAllowedAfterDays.setValidators([
                        Validators.required,
                        Validators.min(1),
                    ]);
                }
                else if (pesticideLifeOfPlant.value === true) {
                    pesticidesAllowedAfterDays.setValue(null);
                    pesticidesAllowedAfterDays.disable();
                    pesticidesAllowedAfterDays.clearValidators();
                }
                else {
                    pesticideLifeOfPlant.setValue(false);
                    pesticidesAllowedAfterDays.enable();
                    pesticidesAllowedAfterDays.setValidators([
                        Validators.required,
                        Validators.min(1),
                    ]);
                }
            }
            else {
                pesticideLifeOfPlant.clearValidators();
                pesticideLifeOfPlant.setValue(null);
                pesticidesAllowedAfterDays.setValue(null);
                pesticidesAllowedAfterDays.disable();
                pesticidesAllowedAfterDays.clearValidators();
            }
            pesticideLifeOfPlant.updateValueAndValidity({ emitEvent: false });
            pesticidesAllowedAfterDays.updateValueAndValidity({ emitEvent: false });
        };
        pesticideLifeOfPlant.valueChanges.subscribe(function () {
            setTimeout(function () { return updateFormState(); }, 0);
        });
        pesticidesAllowed.valueChanges.subscribe(function () {
            setTimeout(function () { return updateFormState(); }, 0);
        });
        setTimeout(function () { return updateFormState(); }, 0);
    };
    ExperimentDesignFormService.prototype.buildTreatment = function (treatmentNumber) {
        var _this = this;
        var numberOfSeedsPerCellControl = this.form.get("numberOfSeedsPerCell");
        var treatment = this.formBuilder.group({
            treatmentNumber: treatmentNumber,
            plantingInstructions: this.formBuilder.group({
                numberToStart: [null, [Validators.required, Validators.min(1)]],
                numberToPots: [null, [Validators.required, Validators.min(0)]],
                numberToHarvest: [null, [Validators.required, Validators.min(0)]],
            }, {
                validator: this.formValidators.plantingInstructionsValidator(0),
            }),
            pottingInstructions: this.formBuilder.group({
                potType: [null, Validators.required],
                substrate: [null, [Validators.required]],
                irrigation: [null, [Validators.required]],
                fertigation: [null, [Validators.required]],
            }),
            flatInstructions: this.formBuilder.group({
                directSeedToPots: [false],
                flatType: [null, [Validators.required]],
                substrate: [null, [Validators.required]],
                irrigation: [null, [Validators.required]],
                fertigation: [null, [Validators.required]],
            }),
            sprayBoothStudy: this.formBuilder.array([
                this.formBuilder.group({
                    actives: this.formBuilder.array([]),
                    adjuvants: this.formBuilder.array([]),
                    applicationTimepointId: [null],
                    applicationVolumeId: [null],
                }),
            ]),
            plantHandlingInstructions: this.formBuilder.group({
                lighting: [null, [Validators.required]],
                temperature: [null, [Validators.required]],
                humidity: [null, [Validators.required]],
                imagingNeeded: [false, [Validators.required]],
                sprayStudy: [false, [Validators.required]],
                sprayStudyChemical: [null],
            }),
        });
        numberOfSeedsPerCellControl.valueChanges.subscribe(function (_) {
            _this.updatePlantingInstructions(treatmentNumber);
        });
        treatment
            .get("plantHandlingInstructions.sprayStudy")
            .valueChanges.subscribe(function (value) {
            var sprayStudyChemical = treatment.get("plantHandlingInstructions.sprayStudyChemical");
            if (value === true) {
                sprayStudyChemical.setValidators(Validators.required);
                sprayStudyChemical.updateValueAndValidity();
            }
            else {
                sprayStudyChemical.clearValidators();
                sprayStudyChemical.updateValueAndValidity();
            }
        });
        treatment
            .get("flatInstructions.directSeedToPots")
            .valueChanges.subscribe(function (value) {
            var flatType = treatment.get("flatInstructions.flatType");
            var substrate = treatment.get("flatInstructions.substrate");
            var irrigation = treatment.get("flatInstructions.irrigation");
            var fertigation = treatment.get("flatInstructions.fertigation");
            if (value === true) {
                flatType.clearValidators();
                substrate.clearValidators();
                irrigation.clearValidators();
                fertigation.clearValidators();
            }
            else {
                flatType.setValidators(Validators.required);
                substrate.setValidators(Validators.required);
                irrigation.setValidators(Validators.required);
                fertigation.setValidators(Validators.required);
            }
            flatType.updateValueAndValidity();
            substrate.updateValueAndValidity();
            irrigation.updateValueAndValidity();
            fertigation.updateValueAndValidity();
        });
        var isSprayStudyOn = !!this.form.get('sprayStudy').value;
        this.applySprayStudyValidatorsToTreatment(treatment, isSprayStudyOn);
        return treatment;
    };
    ExperimentDesignFormService.prototype.applySprayStudyValidatorsToAllTreatments = function (isOn) {
        var treatmentsFA = this.form.get('treatments');
        for (var i = 0; i < treatmentsFA.length; i++) {
            var treatment = treatmentsFA.at(i);
            this.applySprayStudyValidatorsToTreatment(treatment, isOn);
        }
    };
    ExperimentDesignFormService.prototype.applySprayStudyValidatorsToTreatment = function (treatment, isOn) {
        var _this = this;
        var sprayBoothArray = treatment.get('sprayBoothStudy');
        sprayBoothArray.controls.forEach(function (groupCtrl) {
            var sprayBoothGroup = groupCtrl;
            var applicationTimepointId = sprayBoothGroup.get('applicationTimepointId');
            var applicationVolumeId = sprayBoothGroup.get('applicationVolumeId');
            if (isOn) {
                applicationTimepointId.setValidators([Validators.required]);
                applicationVolumeId.setValidators([Validators.required]);
                sprayBoothGroup.setValidators(_this.formValidators.atLeastOneActiveOrAdjuvantValidator());
            }
            else {
                applicationTimepointId.clearValidators();
                applicationVolumeId.clearValidators();
                sprayBoothGroup.clearValidators();
            }
            applicationTimepointId.updateValueAndValidity({ emitEvent: false });
            applicationVolumeId.updateValueAndValidity({ emitEvent: false });
            sprayBoothGroup.updateValueAndValidity({ emitEvent: false });
        });
    };
    ExperimentDesignFormService.prototype.addOrRemoveTreatments = function (numberOfTreatments) {
        var treatmentArray = this.form.get("treatments");
        if (numberOfTreatments > treatmentArray.length) {
            for (var i = treatmentArray.length; i < numberOfTreatments; i++) {
                treatmentArray.push(this.buildTreatment(i + 1));
            }
        }
        else if (numberOfTreatments < treatmentArray.length) {
            for (var i = treatmentArray.length; i > numberOfTreatments - 1; i--) {
                treatmentArray.removeAt(i);
            }
        }
    };
    ExperimentDesignFormService.prototype.initializeSeedNeedsArray = function (design) {
        var _this = this;
        var seedNeedsArray = this.formBuilder.array([]);
        for (var i = 0; i < design.requestedSeed.length; i++) {
            var treatmentArray = this.formBuilder.array([]);
            var _loop_1 = function (treatmentNumber) {
                var seedCount = this_1.formBuilder.control({ value: 0, disabled: false }, [Validators.required, Validators.min(0)]);
                treatmentArray.push(this_1.formBuilder.group({
                    treatmentNumber: this_1.formBuilder.control({
                        value: treatmentNumber,
                        disabled: false,
                    }),
                    seedCount: seedCount,
                }));
                seedCount.valueChanges.subscribe(function (c) {
                    _this.updateNumberOfSeedsToStart(treatmentNumber);
                });
            };
            var this_1 = this;
            for (var treatmentNumber = 1; treatmentNumber <= design.numberOfTreatments; treatmentNumber++) {
                _loop_1(treatmentNumber);
            }
            seedNeedsArray.push(this.formBuilder.group({
                requestId: this.formBuilder.control({
                    value: null,
                    disabled: false,
                }),
                entryNumber: this.formBuilder.control({
                    value: null,
                    disabled: false,
                }),
                siid: this.formBuilder.control({ value: null, disabled: false }),
                geName: this.formBuilder.control({ value: null, disabled: false }),
                numberOfSeeds: this.formBuilder.control({
                    value: null,
                    disabled: false,
                }),
                treatments: treatmentArray,
            }, { validator: this.formValidators.seedCountValidator() }));
        }
        return seedNeedsArray;
    };
    ExperimentDesignFormService.prototype.addOrRemoveSeedNeedsTreatments = function (numberOfTreatments) {
        var _this = this;
        var seedNeeds = this.form.get("seedNeeds");
        if (seedNeeds.length === 0)
            return;
        var existingArrayLength = seedNeeds.at(0).get("treatments")
            .length;
        if (numberOfTreatments === existingArrayLength)
            return;
        if (numberOfTreatments > existingArrayLength) {
            for (var _i = 0, _a = seedNeeds.controls; _i < _a.length; _i++) {
                var seedNeed = _a[_i];
                var seedNeedTreatmentArray = seedNeed.get("treatments");
                var _loop_2 = function (treatmentNumber) {
                    var seedCount = this_2.formBuilder.control({ value: 0, disabled: false }, [Validators.required, Validators.min(0)]);
                    seedNeedTreatmentArray.push(this_2.formBuilder.group({
                        treatmentNumber: this_2.formBuilder.control({
                            value: treatmentNumber,
                            disabled: false,
                        }),
                        seedCount: seedCount,
                    }));
                    seedCount.valueChanges.subscribe(function (c) {
                        _this.updateNumberOfSeedsToStart(treatmentNumber);
                    });
                };
                var this_2 = this;
                for (var treatmentNumber = seedNeedTreatmentArray.length + 1; treatmentNumber <= numberOfTreatments; treatmentNumber++) {
                    _loop_2(treatmentNumber);
                }
            }
        }
        else if (numberOfTreatments < existingArrayLength) {
            for (var _b = 0, _c = seedNeeds.controls; _b < _c.length; _b++) {
                var seedNeed = _c[_b];
                var seedNeedTreatmentArray = seedNeed.get("treatments");
                for (var i = existingArrayLength; i > numberOfTreatments - 1; i--) {
                    seedNeedTreatmentArray.removeAt(i);
                }
            }
        }
        this.clearSeedCounts();
    };
    ExperimentDesignFormService.prototype.updateNumberOfSeedsToStart = function (treatmentNumber) {
        var treatments = this.formGroup.get("treatments").at(treatmentNumber - 1);
        var plantingInstructions = (treatments.get("plantingInstructions"));
        var numberToStart = (plantingInstructions.get("numberToStart"));
        var numberToStartTotal = 0;
        var seedNeeds = this.formGroup.get("seedNeeds");
        for (var _i = 0, _a = seedNeeds.controls; _i < _a.length; _i++) {
            var seedNeed = _a[_i];
            var seedNeedsTreatment = seedNeed.get("treatments").at(treatmentNumber - 1);
            numberToStartTotal += seedNeedsTreatment.get("seedCount").value;
        }
        numberToStart.patchValue(numberToStartTotal);
        plantingInstructions.updateValueAndValidity();
        this.updatePlantingInstructions(treatmentNumber);
    };
    ExperimentDesignFormService.prototype.clearSeedCounts = function () {
        var seedNeeds = this.form.get("seedNeeds");
        for (var _i = 0, _a = seedNeeds.controls; _i < _a.length; _i++) {
            var seedNeed = _a[_i];
            var treatmentArray = seedNeed.get("treatments");
            for (var _b = 0, _c = treatmentArray.controls; _b < _c.length; _b++) {
                var treatment = _c[_b];
                var seedCount = treatment.get("seedCount");
                seedCount.patchValue(0);
            }
        }
    };
    ExperimentDesignFormService.prototype.updatePlantingInstructions = function (treatmentNumber) {
        var treatments = this.formGroup.get("treatments").at(treatmentNumber - 1);
        var plantingInstructions = (treatments.get("plantingInstructions"));
        var numberOfEuids = this.getNumberOfEuids(treatmentNumber);
        plantingInstructions.clearValidators();
        plantingInstructions.setValidators(this.formValidators.plantingInstructionsValidator(numberOfEuids));
        plantingInstructions.updateValueAndValidity();
    };
    ExperimentDesignFormService.prototype.getNumberOfEuids = function (treatmentNumber) {
        var numberOfSeedsPerCellControl = this.form.get("numberOfSeedsPerCell");
        var seedNeeds = this.formGroup.get("seedNeeds");
        var numberOfEuids = 0;
        for (var _i = 0, _a = seedNeeds.controls; _i < _a.length; _i++) {
            var seedNeed = _a[_i];
            var seedNeedsTreatment = seedNeed.get("treatments").at(treatmentNumber - 1);
            numberOfEuids += Math.ceil(seedNeedsTreatment.get("seedCount").value /
                numberOfSeedsPerCellControl.value);
        }
        return numberOfEuids;
    };
    return ExperimentDesignFormService;
}());



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/request-creation/experiment-design/experiment-design-form/experiment-design-form-builder.service.ts.pre-build-optimizer.js